import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ServerSelectView = _resolveComponent("ServerSelectView")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: _ctx.$t('screenTitle.charGameFunc')
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        model: _ctx.formModel,
        onFinish: _ctx.onFinish,
        rules: _ctx.formRule,
        scrollToFirstError: true,
        layout: "vertical"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "Máy chủ",
            name: "server_id"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ServerSelectView, {
                modelValue: _ctx.formModel.server_id,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formModel.server_id) = $event)),
                  _ctx.getServerChars
                ]
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "Nhân vật",
            name: "charguid"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                disabled: !_ctx.formModel.server_id || !_ctx.optionsChars.length,
                value: _ctx.formModel.charguid,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formModel.charguid) = $event)),
                options: _ctx.optionsChars
              }, null, 8, ["disabled", "value", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "Chức năng",
            name: "game_func"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.formModel.game_func,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formModel.game_func) = $event)),
                options: _ctx.optionsGameFuncs
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                "html-type": "submit",
                block: "",
                loading: _ctx.isLoading
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('text.process')), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "onFinish", "rules"])
    ]),
    _: 1
  }, 8, ["title"]))
}